<template>
    <div class="flex items-center text-sm" :class="variantStyles[variant]">
        <SvgComponent :icon="variant" class="mr-1 shrink-0">Icon</SvgComponent>
        <div v-html="text" />
    </div>
</template>

<script setup lang="ts">
defineProps<{
    text: string;
    variant: 'error' | 'info' | 'success' | 'warning';
}>();

const variantStyles = {
    error: 'text-functional-error',
    info: 'text-functional-information',
    success: 'text-functional-success',
    warning: 'text-functional-warning',
};
</script>
